/**
 * ChatVideoPlayerStatusMessageHandler
 * This class will handle "chat.video_player_status" type messages received from CR.
 * For future features .processMessage() method should be created.
 * For now it uses stub from AbstractMessageHandler.
 * @extends: ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatVideoPlayerStatusMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_VIDEOPLAYER_STATUS);
};

$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
					com.inq.flash.client.control.messagehandlers.ChatVideoPlayerStatusMessageHandler,
					'com.inq.flash.client.control.messagehandlers.ChatVideoPlayerStatusMessageHandler');

